// TODO: to delete later
// export const tokenIsExpired = (user?: AuthUserData) => {
// 	const unixNow = Math.floor(Date.now() / 1000);
// 	// 10 seconds before token expired.
// 	return !user || unixNow + 10 > user.expiration;
// };
export const tokenIsExpired = (expiration) => {
    const unixNow = Math.floor(Date.now() / 1000);
    // 10 seconds before token expired.
    return !expiration || unixNow + 10 > expiration;
};
